module.exports = __webpack_public_path__ + "static/pans-cd854446756be5c875e4d869579fb6ab.png";